module.exports = __webpack_public_path__ + "img/hakata_businesscenter.f8d4187a.jpg";